import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import ButtonWrapper from "../../components/Button";
import GoogleMap from "../../reusableComponents/GoogleMap";

const mapHtml = ` 
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Google Map Latitude and Longitude</title>
    <style>
        /* Set the size of the map */
        #map {
            height: 400px;
            width: 100%;
        }
        /* Optional: Make the page content centered */
        body {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: Arial, sans-serif;
        }
    </style>
</head>
<body>
    <h1>Google Map Latitude and Longitude</h1>
    <p>Enter Latitude and Longitude to center the map:</p>
    
    <label for="lat">Latitude: </label>
    <input type="number" id="lat" value="28.6139" step="any">
    <label for="lng">Longitude: </label>
    <input type="number" id="lng" value="77.2090" step="any">
    <button onclick="updateMap()">Update Map</button>
    
    <!-- The div element where the map will be displayed -->
    <div id="map"></div>

    <!-- Load the Google Maps JavaScript API -->
    <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY_HERE&callback=initMap" async defer></script>
    <script>
        let map;

        // Initialize and add the map
        function initMap() {
            // The initial location (New Delhi)
            const initialLocation = { lat: 28.6139, lng: 77.2090 };

            // The map, centered at the initial location
            map = new google.maps.Map(document.getElementById("map"), {
                zoom: 10,
                center: initialLocation,
            });

            // The marker, positioned at the initial location
            new google.maps.Marker({
                position: initialLocation,
                map: map,
            });
        }

        // Function to update the map based on user input
        function updateMap() {
            const lat = parseFloat(document.getElementById('lat').value);
            const lng = parseFloat(document.getElementById('lng').value);

            const newLocation = { lat: lat, lng: lng };

            // Update the map's center
            map.setCenter(newLocation);

            // Update the marker position
            new google.maps.Marker({
                position: newLocation,
                map: map,
            });
        }
    </script>
</body>
</html>

`;

const inputWidth = 200;
const Step3 = ({ formData, isUpdating, handleTabChange }) => {
  const [coordinate, setCoordinate] = useState([{ latitude: "", longitude: "" }]);
  const [googleLocation, setGoogleLocation] = useState("");

  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: coordinate,
      googleMapLocation: googleLocation,
    },
  };
  const { handleSubmit, control, watch, setValue, reset } = useForm({ defaultValues });

  const onSubmit = (data) => {
    console.log("data_from_tab3", data);
    data.descriptionOfLand = {
      ...formData.descriptionOfLand,
      googleMapCoordinates: (coordinate?.[0]?.latitude === "" || coordinate?.[0]?.longitude === "") ? formData?.descriptionOfLand?.googleMapCoordinates : coordinate,
      googleMapLocation: googleLocation || formData?.descriptionOfLand?.googleMapLocation
    }

    handleTabChange(2, data);
  };
  return (
    <section className="container1" style={{ marginTop: "20px" }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">{/* <h2 className="formHeading">Checklist to be filled</h2> */}</div>
          <div className="formInputContainer">
            <GoogleMap
              formData={formData}
              coordinate={coordinate}
              setCoordinate={setCoordinate}
              googleLocation={googleLocation}
              setGoogleLocation={setGoogleLocation}
            />
          </div>
        </div>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              sx={{
                backgroundColor: "#eee",
                "&:hover": {
                  backgroundColor: "#e5e5e5",
                },
                color: "#000",
              }}
              variant="contained"
              size="medium"
              label="Prev"
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save and Continue" type="submit" disabled={isUpdating} />

            <ButtonWrapper variant="contained" color="error" size="medium" label="Reset" />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step3;
